import Vue from 'vue'
import Header from '../../components/Header';
import Footer from '../../components/Footer';


Vue.component('Header', Header);
Vue.component('Footer', Footer);
